
class handleListFilters {
  _construct() {
    this.$selects = document.querySelectorAll('.select-trigger-filter');
  }

  _sendFilters($el) {
    let $form = $el.closest('form');
    $form.submit();
  }

  init() {
    this._construct();
    const self = this;

    self.$selects.forEach(function($select) {
      $select.addEventListener('change', function() {
        self._sendFilters($select);
      });
    });
  }
}

export default handleListFilters
